import React, { createContext, useReducer } from 'react'

export const SET_WIRE_DATA = 'SET_WIRE_DATA'
export const UPDATE_WIRE_DATA = 'UPDATE_WIRE_DATA'
export const SET_SELECTED_WIRE_DATA = 'SET_SELECTED_WIRE_DATA'

export const SET_SHOW_HIDE_WIRE_POPUP = 'SET_SHOW_HIDE_WIRE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_WIRE_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_WIRE_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return {
        ...data,
        data: tempData,
        showWireFormPopup: false,
        selectedObject: {},
      }
    }
    case SET_SELECTED_WIRE_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showWireFormPopup: true,
      }
    }
    case SET_SHOW_HIDE_WIRE_POPUP: {
      if (payload.data) {
        return { ...data, showWireFormPopup: payload.data }
      } else {
        return {
          ...data,
          showWireFormPopup: payload.data,
          selectedObject: {},
        }
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: {},
  selectedObject: {},
  showWireFormPopup: false,
}

const WireStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <WireContext.Provider value={[state, dispatch]}>
      {children}
    </WireContext.Provider>
  )
}

export const WireContext = createContext(initialState)
export default WireStore
